import React from "react";
import Footer from "../components/Footer/Footer"
import Hero from "../components/Hero/Hero"
import Navbar from "../components/Navbar/Navbar"

const About = () => {
    return (
        <>
            <Navbar/>
            <Hero/>
            <Footer/>
        </>
    )
}

export default About;
